import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-media-consumption-table',
  templateUrl: './media-consumption-table.component.html',
  styleUrls: ['./media-consumption-table.component.scss']
})
export class MediaConsumptionTableComponent {
  @Input() rows: any[] = [];
}
